import Vue from "vue";
import App from "./App.vue";

import router from "@/routes";
import store from "@/store";

//plugin
import Toasted from "vue-toasted";
import {
  MdField,
  MdMenu,
  MdList,
  MdChips,
  MdRadio,
  MdButton,
  MdProgress,
  MdAutocomplete,
  MdSwitch,
  MdDialog,
  MdDialogConfirm,
  MdCard,
  MdRipple,
  MdTable,
  MdContent,
  MdEmptyState,
  MdCheckbox,
  MdSubheader,
  MdDivider
} from "vue-material/dist/components";
import Vuelidate from "vuelidate";
import VCalendar from "v-calendar";
import VueMask from "v-mask";
//plugin css
import "vue-material/dist/vue-material.min.css";
import "vue-material/dist/theme/default.css";
import "./assets/styles/8-trumps/vue-material.scss";

import "v-calendar/lib/v-calendar.min.css";

import numeral from 'numeral';

import VModal from 'vue-js-modal';

Vue.config.productionTip = true;
Vue.config.devtools = true
Vue.use(Toasted);
Vue.use(VueMask);
//vue material
Vue.use(MdField);
Vue.use(MdMenu);
Vue.use(MdList);
Vue.use(MdRadio);
Vue.use(MdChips);
Vue.use(MdButton);
Vue.use(MdProgress);
Vue.use(MdAutocomplete);
Vue.use(MdSwitch);
Vue.use(MdDialog);
Vue.use(MdDialogConfirm);
Vue.use(MdCard);
Vue.use(MdRipple);
Vue.use(MdTable);
Vue.use(MdContent);
Vue.use(MdEmptyState);
Vue.use(MdCheckbox);
Vue.use(MdSubheader);
Vue.use(MdDivider);

Vue.use(Vuelidate);

Vue.use(VModal);

Vue.use(VCalendar, {
  locale: "es",
  firstDayOfWeek: 2
});

Vue.filter("decimals", val => {
  if (typeof val == "string") return val;
  return Number(val).toFixed(2);
});
Vue.filter("decimales", val => {
  if(typeof val === "boolean") return val
  if (isNaN(Number(val))) return val;
  // return new Intl.NumberFormat('es-PE', { style: 'currency', currency: 'PEN', currencySign: "accounting", currencyDisplay: "symbol" }).format(val);
  return `${numeral(val).format("0,0.00")}`;
});
Vue.filter("currency", val => {
  if(typeof val === "boolean") return val
  if (isNaN(Number(val))) return val;
  // return new Intl.NumberFormat('es-PE', { style: 'currency', currency: 'PEN', currencySign: "accounting", currencyDisplay: "symbol" }).format(val);
  return `S/ ${numeral(val).format("0,0.00")}`;
});
Vue.filter("currencyUSD", val => {
  if(typeof val === "boolean") return val
  if (isNaN(Number(val))) return val;
  // return new Intl.NumberFormat('es-PE', { style: 'currency', currency: 'PEN', currencySign: "accounting", currencyDisplay: "symbol" }).format(val);
  return `$ ${numeral(val).format("0,0.00")}`;
});
Vue.filter("formatDate", val => {
  return new Date(val).toLocaleDateString('es-PE');
})

Vue.directive("decimal", {
  update: function(el, binding, vnode){
    console.log("directive decimal, ", el);
    const originalValue = el.value;
    // console.log(originalValue);
    const newValue = `${numeral(originalValue).format("0,0.00")}`;
    // console.log(newValue);
    // el.value = newValue
    el.setAttribute("value", newValue);
    console.log({originalValue, newValue, "el.value": el.value, vnode});
    // if(!isNaN(Number(originalValue))) el.innerHTML = `${numeral(originalValue).format("0,0.00")}`
  }
})

new Vue({
  render: h => h(App),
  router,
  store
}).$mount("#app");
